import { render, staticRenderFns } from "./checkStandingBook.vue?vue&type=template&id=56565bb8&scoped=true&"
import script from "./checkStandingBook.vue?vue&type=script&lang=js&"
export * from "./checkStandingBook.vue?vue&type=script&lang=js&"
import style0 from "./checkStandingBook.vue?vue&type=style&index=0&id=56565bb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56565bb8",
  null
  
)

export default component.exports